import { Transition } from '@headlessui/react'
import cx from 'classnames'
import type { ReactNode } from 'react'
import { type Toast, toast as rhtoast } from 'react-hot-toast'

import { Alert } from '../alert/Alert'

/**
 * Success and error toasts
 *
 * Only these two variants are supported to limit the API surface and UX consistency.
 * Should we need more variants in the future we can add them here or consider using the https://react-hot-toast.com/docs/toast-bar#toastbar--api API.
 */
export const toast = ({
  title,
  message,
  variant,
}: {
  title: string
  message?: ReactNode
  variant: 'success' | 'error'
}) =>
  rhtoast.custom(({ visible }: Toast) => (
    <Transition
      appear
      show={visible}
      enter="transition duration-300"
      enterFrom="opacity-0 translate-x-2"
      enterTo="opacity-100 translate-x-0"
      leave="transition"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <Alert
        title={title}
        severity={variant}
        className={cx(
          'max-w-md shadow-lg',
          { error: 'shadow-error-800/25', success: 'shadow-success-800/25' }[
            variant
          ],
        )}
      >
        {message}
      </Alert>
    </Transition>
  ))
